import { useTranslation } from 'react-i18next';
import Drawer from 'react-modern-drawer';

function DefaultDrawer({isOpen, toggle, size = 400, children}) {
  const { i18n } = useTranslation();

  const DRAWER_WIDTH = window.innerWidth < 768 ? window.innerWidth : size;

  return(
    <Drawer
      open={isOpen}
      onClose={toggle}
      direction={ i18n.language === 'ar' ? 'left' : 'right' }
      size={DRAWER_WIDTH}
      enableOverlay={true}
      zIndex={9000}
      duration={200}
    >
      { children }
    </Drawer>
  );
}

export default DefaultDrawer;